export enum ChartModeEnum {
  Month = '1d',
  Year = '1m',
}
